const BASE_URL = process.env.NODE_ENV === 'development' ? '' : 'https://app.mydatavalue.com'

export const fetchFromAPI = async (
  input: string | URL | globalThis.Request,
  init?: RequestInit
): Promise<Response> => {
  return fetch(
    `${BASE_URL}/${input}`,
    init
  ).then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.statusText}`);
    }
    return response;
  });
};

export const fetchFromBookingAPI = async (
  input: string | URL | globalThis.Request,
  init?: RequestInit
): Promise<Response> => {
  return fetchFromAPI(
    `api/booking/${input}`,
    init
  );
};

export const fetchFromPMSAPI = async (
  input: string | URL | globalThis.Request,
  init?: RequestInit
): Promise<Response> => {
  return fetchFromAPI(
    `api/pms/${input}`,
    init
  );
};